import { BasketPopupRecommendations } from './product-detail/ProductTypes';

export type EssentialsContainerProps = {
  basketPopUp: BasketPopupRecommendations;
};
